let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bYycz")).then(() => parcelRequire('8Mphp'));